import { VrService } from './../../services/vr.service';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Component, ViewChild } from '@angular/core';
import { StorageService } from './../../providers/storage.service';
import { LotteryLatestService } from './../../services/lotteryLatest.service';
import { LotteryModel } from './../../models/lottery.model';
import { AlertController, ModalController, NavController, NavParams, Slides, Events, ToastController, App } from 'ionic-angular';
import { SysconfigModel } from '../../models/user.model';
import { LotteryAllPage } from '../lottery-all/lottery-all';
import { BettingOrderPage } from './../../pages/bettingorder/bettingorder'
import { BettingParamService } from '../../services/betting.param.service';
import { SigninPage } from '../signin/signin';
import { ActivityPage } from '../activity/activity';
import { RechargePage } from '../recharge/recharge';
import { WithdrawPage } from '../withdraw/withdraw';
import { NormalReport } from '../normalreport/normalreport';
import { PromotionPage } from '../promotion/promotion';
import { AppConfig } from '../../app/app.config';
import { SignalrService } from '../../providers/signalr.service';
import { AuthService } from "../../providers/auth.service";
import { AlertService } from "../../providers/alert.service";
import { AgService } from './../../services/ag.service';
import { KaiYuanService } from '../../services/kaiyuan.service';
import { SysconfigService } from '../../services/sysconfig.service';
import { LoaddingService } from '../../providers/loadding.service';
import { EbetService } from '../../services/ebet.service';
import { ImService } from '../im/im.service';
import { ChatService } from '../../services/chat.service';
import { ImPage } from '../im/im';
import { RevisePage } from '../password/revise';

// import { slideTo, slideNext, slidePrev, update, initSwiper, destroySwiper, startAutoplay, stopAutoplay } from './swiper/swiper';
import { GamMaService } from './../../services/gamMa.service';
import { ImGamingService } from './../../services/imgaming.service';
import { ShaBaService } from './../../services/shaba.service';
import { SigninService } from '../../services/signin.service';
import { YaBoService } from '../../services/yabo.service';
import { YaBoLiveService } from '../../services/yabolive.service';
import { BaiShengService } from '../../services/baisheng.service';
import { YaXingService } from '../../services/yaxing.service';
import { KaiXuanService } from '../../services/kaixuan.service';
import { PmService } from '../../services/pm.service';
import { UserBankService } from '../../services/userbank.service';
import { UserVarifyService } from '../../services/userVarify.service';
import { UserBankList } from '../userbanks/userbanklist';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  providers: [
    LotteryLatestService,
    SignalrService,
    AgService,
    VrService,
    SigninService,
    YaBoService,
    YaBoLiveService,
    UserVarifyService,
    UserBankService,
    BaiShengService, YaXingService, KaiXuanService, PmService]
})
export class HomePage {
  homeArr = [];//轮播图片组
  all: LotteryModel[] = [];
  lotterys: LotteryModel[] = [];
  flagChecked = 0;
  likes = [];

  @ViewChild('lunbo') slider: Slides;

  excludeTracks = [];
  GASecret: string;
  userInformation = this.config.getCurrentUser();
  ugUrl = '';

  lunboOptions = {
    autoplay: 2000,
    initialSlide: 0,
    pager: true,
    loop: true,
    speed: 1000
  };

  unreadMessage: number;  //未读消息
  isShowUnreadMessage: boolean = false;  //是否显示未读消息的小红点
  getMessageCount;
  totalMessage: number = 0;
  isShowIcon: boolean = true;   //是否显示首页头部聊天图标

  isShowKaiYuan: boolean = false;
  isShowGamMa: boolean = false;
  isShowYaBo: boolean = false;
  isShowYaBoLive: boolean = false;
  isShowEbet: boolean = false;
  isShowIM: boolean = false;
  isShowAio: boolean = false;
  isShowBaiSheng: boolean = false;
  isShowImt: boolean = false;
  isShowCr: boolean = false;
  isShowPG: boolean = false;
  isShowOb: boolean = false;
  isShowKaiXuan: boolean = false;
  isShowYx: boolean = false;
  isShowAg: boolean = false;
  isShowPm: boolean = false;
  isShowBg: boolean = false;
  isShowOuBo: boolean = false;
  thirdGameList = [];
  agRate = 0;
  recommonList: any = [];
  constructor(
    private auth: AuthService,
    public navCtrl: NavController,
    public navParms: NavParams,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public storage: StorageService,
    private lotterylatestService: LotteryLatestService,
    private config: AppConfig,
    private signalrService: SignalrService,
    private alert: AlertService,
    private agService: AgService,
    private iab: InAppBrowser,
    private vrService: VrService,
    private kaiYuanService: KaiYuanService,
    private sys: SysconfigService,
    private loadding: LoaddingService,
    private ebetService: EbetService,
    private chatService: ChatService,
    public toastCtrl: ToastController,
    private events: Events,
    private gamMaService: GamMaService,
    private imService: ImGamingService,
    private sbService: ShaBaService,
    private signinService: SigninService,
    private appCtrl: App,
    private yaboService: YaBoService,
    private yaboliveService: YaBoLiveService,
    private bsService: BaiShengService,
    private yxService: YaXingService,
    private kxService: KaiXuanService,
    private userService: UserVarifyService,
    private userbank: UserBankService,
    private pmService: PmService
  ) {
    if (this.auth.loggedIn() && !AppConfig.connected) {
      signalrService.init();
    }
  }

  ionViewDidLoad() {
    this.getOpenGames();
    this.getLotterysAll().then(s => {
      this.lotterys = this.config.getLotterys();
      this.likes = this.config.getLikes();
      this.all = this.likes == null || this.likes.length == 0 ? this.lotterys : this.likes;
      const list: any = this.storage.read('lotterys');
      if(list) {
        let Recommend: any[] = [];
        list.forEach((item: any) => { if (item.IsRecommend == true) { Recommend.push(item); } });
        Recommend.sort((a, b) => { return a.RecommendSerials - b.RecommendSerials });
        this.recommonList = Recommend;
      }
    });
    this.getMobilePic()
    this.getChatSetting();
    this.showpassword();
    this.getThirdIsOpen();
  }

  /**
   * 获取所有第三方游戏
   * @memberof PagesComponent
   */
  getOpenGames() {
    this.imService.getOpenGames().then(s => {
      if (s.length) {
        this.thirdGameList = [];
        s[0].Games.forEach(el => {
          if (el.Code == 'ag') {
            this.agRate = el.ExtraRabateRate ? el.ExtraRabateRate * 100 : 0;
          }
          let obj = {
            code: el.Code,
            name: el.Name,
            status: true,
            isOpen: false,
            ExtraRabateRate: el.ExtraRabateRate ? el.ExtraRabateRate * 100 : 0,
          }
          this.thirdGameList.push(obj);
          this.storage.write('THIRD_GAMES', this.thirdGameList);
        });
      }
    }).catch(c => {
      console.log(c)
    })
  }

  loginThird(code) {
    switch (code) {
      case 'ag':
        this.forwardGame(0);
        break;
      case 'bg':
        this.getBgIsOpen();
        break;
      case 'bs':
        this.getBaiShengIsOpen();
        break;
      case 'cr':
        this.getCRIsOpen();
        break;
      case 'ebet':
        this.getEbetIsOpen();
        break;
      case 'im':
        this.getIMIsOpen();
        break;
      case 'im2':
        this.getImtIsOpen();
        break;
      case 'jm':
        this.getGamMaIsOpen();
        break;
      case 'kx':
        this.getKaiXuanIsOpen();
        break;
      case 'ky':
        this.getKaiYuanIsOpen();
        break;
      case 'ob':
        this.getObIsOpen();
        break;
      case 'oubo':
        this.getOuBoIsOpen();
        break;
      case 'pg':
        this.getPGIsOpen();
        break;
      case 'pmreal':
        this.getPmIsOpen();
        break;
      case 'sb':
        this.openAio();
        break;
      case 'yx':
        this.getYxIsOpen();
        break;
      case 'yb':
        this.getYaBoIsOpen();
        break;
      case 'yblive':
        this.getYaBoLiveIsOpen();
        break;
      default:
        this.newThirdLogin(code);
        break;
    }
  }

  /** 新三方游戏登录 */
  newThirdLogin(code) {
    this.imService.thirdLogin(code).then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      } else {
        this.alert.showAlert(res.Error)
      }
    })
  }

  // 判断第三方游戏是否开启
  getThirdIsOpen() {
    this.sys.getThirdIsOpen().then(s => {
      this.isShowKaiYuan = s.ky;
      this.isShowGamMa = s.jm;
      this.isShowYaBo = s.yb;
      this.isShowYaBoLive = s.yblive;
      this.isShowEbet = s.ebet;
      this.isShowIM = s.im;
      this.isShowAio = s.sb;
      this.isShowBaiSheng = s.bs;
      this.isShowImt = s.im2;
      this.isShowCr = s.cr;
      this.isShowPG = s.pg;
      this.isShowOb = s.ob;
      this.isShowKaiXuan = s.kx;
      this.isShowYx = s.yx;
      this.isShowPm = s.pmreal;
      this.isShowAg = s.ag;
      this.isShowBg = s.bg;
      this.isShowOuBo = s.oubo;

    })
  }

  bindStatus = {
    isBindPassword: false,
    isBindCard: false,
  };

  ionViewWillEnter() {
    this.getBindStatus();
  }

  getBindStatus() {
    const googleCkParams = { isShow: false, "pwd": "", "chkSign": "0" };
    this.userService.ckBankPassword(googleCkParams).then(s => {
      this.bindStatus.isBindPassword = s['Result'];
      this.storage.write('isBindPassword', s['Result']);
    });
    const getUserBanksInput = { pageIndex: 1, pageSize: 30 };
    this.userbank.getUserBanks(getUserBanksInput.pageIndex, getUserBanksInput.pageSize).then((s: any) => {
      this.storage.write('userBanksCache', s);
      this.bindStatus.isBindCard = s && s.length;
    })
  }

  //验证密码是否简单
  showpassword() {
    const userPassword = this.storage.readString("userpwd");
    let password = null;
    if (userPassword) {
      password = AppConfig.decodeBase64(this.storage.readString("userpwd"));
    }
    if (AppConfig.User && !AppConfig.User.GASecret) {
      this.signinService.IsCkSimplePwd({ userpwd: password }).then(s => {
        if (s.Result) {
          this.alert.showConfirms("由于您的登陆密码过于简单，建议您修改登录密码，并绑定谷歌登陆验证器，提高账户安全性。（纯数字；单个字母加连贯数字；与账户相同的密码都为简单密码）。", () => {
            let modal = this.modalCtrl.create(RevisePage, {});
            modal.present();
          })
        } else if (!s.Result && s.Error !== '合格') {
          this.alert.showAlert(s.Error);
        }
      }).catch(err => { });
    }
  }

  ionViewDidEnter() {
    this.getUnreadMessage();
    clearInterval(ImService.getMessageCount);
    ImService.getMessageCount = setInterval(() => {
      this.getUnreadMessage();
    }, 7000)

  }


  // 获取未读消息总数  David 2019-08-03
  getUnreadMessage() {
    this.chatService.getUnreadMessageCount().then(s => {
      let totalMsg: any = this.storage.read("totalMessage");
      if (totalMsg >= 0 && s.Parameter2 !== 0) {
        this.unreadMessage = s.Parameter2;
        this.isShowUnreadMessage = true;
        // 比较上一次的未读消息数，如果大于上一次，表示有新消息，则弹窗提醒
        if (totalMsg !== s.Parameter2) {
          let isShowNewMsg = this.storage.read('newmsg');
          if (isShowNewMsg == null) {
            isShowNewMsg = AppConfig.isShowNewMsg;
            if (isShowNewMsg) {
              const toast = this.toastCtrl.create({
                message: `您有${s.Parameter2}条未读消息~`,
                duration: 3000,
                position: 'top',
                cssClass: 'style-toast'
              });
              toast.present();
            }
          } else if (isShowNewMsg) {
            const toast = this.toastCtrl.create({
              message: `您有${s.Parameter2}条未读消息~`,
              duration: 3000,
              position: 'top',
              cssClass: 'style-toast'
            });
            toast.present();
          }
          this.storage.write("totalMessage", s.Parameter2);
          this.totalMessage = s.Parameter2;
          this.isShowUnreadMessage = true;
          this.unreadMessage = s.Parameter2;
        }
      }
      else {
        this.storage.write("totalMessage", s.Parameter2);
        this.unreadMessage = s.Parameter2;
        if (this.unreadMessage > 0) {
          this.isShowUnreadMessage = true
        } else {
          this.isShowUnreadMessage = false
        }
      }

      this.events.publish('unreadMessage', this.unreadMessage);
    }).catch(e => {
      if (e.status === 401 || e.status === 403) {
        clearInterval(ImService.getMessageCount);
        this.alert.showAlert("验证已失效，您需要退出重新登录!");
        localStorage.clear();
        this.appCtrl.getRootNav().setRoot(SigninPage);
      } else if (e.status === 331) {
        clearInterval(ImService.getMessageCount);
      }
    })
  }


  // 进入其他页面，清除轮询
  ionViewDidLeave() {
    clearInterval(ImService.getMessageCount);
    this.storage.remove("totalMessage");
  }
  /**
   * 打开BS百胜棋牌界面
   */
  getBaiShengIsOpen() {
    const load = this.loadding.showLoding();
    this.bsService.loginBaiSheng().then(s => {
      this.loadding.closeLoading(load);
      if (s.Result) {
        this.alert.showConfirm('新窗口打开游戏', () => {
          this.config.openUrl(s.Error);
        });
      } else {
        this.alert.showAlert(s.Error);
        return;
      }
    }).catch(s => {
      this.loadding.closeLoading(load);
      if (s.status === 401 || s.status === 403) {
        this.alert.showAlert("验证已失效，您需要退出重新登录!");
        localStorage.clear();
        this.appCtrl.getRootNav().setRoot(SigninPage);
      } if (s.status == 500) {
        this.alert.showAlert("即将开放，敬请期待!");
      }
    });
  }
  /**
   * 获取聊天开关
   */
  getChatSetting() {
    this.chatService.getChatSetting().then(s => {
      if (s) {
        this.isShowIcon = s.Parameter2.IsOpenChatMessage;
      }
    }).catch(err => { })
  }

  /** 进入聊天页面 */
  enterIm() {
    this.navCtrl.push(ImPage);
  }
  /**
   * 进入AIO沙巴体育
   */
  openAio() {
    let load = this.loadding.showLoding();
    this.sbService.login().then(s => {
      if (s && s.Result) {
        this.loadding.closeLoading(load);
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(s.Error);
        });
        // this.loadding.closeLoading(load);

      } else {
        this.loadding.closeLoading(load);
        this.alert.showAlert(s.Error);
      }
    }).catch(err => {
      this.loadding.closeLoading(load);
      this.alert.showAlert("即将开放，敬请期待!");
    });
  }
  /**
   * 进入亚博棋牌
   */
  getYaBoIsOpen() {
    let load = this.loadding.showLoding();
    this.yaboService.loginYaBo().then(s => {
      if (s && s.Result) {
        this.loadding.closeLoading(load);
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(s.Error);
        });
        // this.loadding.closeLoading(load);

      } else {
        this.loadding.closeLoading(load);
        this.alert.showAlert(s.Error);
      }
    }).catch(err => {
      this.loadding.closeLoading(load);
      this.alert.showAlert("即将开放，敬请期待!");
    });
  }

  /**
   * 进入亚博真人
   */
  getYaBoLiveIsOpen() {
    let load = this.loadding.showLoding();
    this.yaboliveService.loginYaBoLive().then(s => {
      if (s && s.Result) {
        this.loadding.closeLoading(load);
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(s.Error);
        });
        // this.loadding.closeLoading(load);

      } else {
        this.loadding.closeLoading(load);
        this.alert.showAlert(s.Error);
      }
    }).catch(err => {
      this.loadding.closeLoading(load);
      this.alert.showAlert("即将开放，敬请期待!");
    });
  }
  /**
   * 判断IM是否开启
   * An 2019-12-24
   */
  getIMIsOpen() {
    let load = this.loadding.showLoding();
    this.imService.imdjIsOpen().then(s => {
      if (s && s.Result) {
        this.openIM();
        this.loadding.closeLoading(load);
      } else {
        this.alert.showAlert("即将开放，敬请期待!");
        this.loadding.closeLoading(load);
        return;
      }
    }).catch((err) => {
      this.alert.showAlert("即将开放，敬请期待!");
      this.loadding.closeLoading(load);
      return;
    })
  }
  /**
    * 判断ebet是否开启
    * david 2019-03-20
    * @memberof GamesLobbyPage
    */
  getEbetIsOpen() {
    let load = this.loadding.showLoding();
    this.ebetService.ebetStatus().then(s => {
      if (s && s.Result) {
        this.openEbet();
        this.loadding.closeLoading(load);
      } else {
        this.alert.showAlert("即将开放，敬请期待!");
        this.loadding.closeLoading(load);
        return;
      }
    }).catch((err) => {
      this.alert.showAlert("即将开放，敬请期待!");
      this.loadding.closeLoading(load);
      return;
    })
  }
  /**
   * 进入IM
   * An 2019-12-24
   */
  openIM() {
    let load = this.loadding.showLoding();
    this.imService.login().then(s => {
      if (s && s.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(s.Error);
        });
        this.loadding.closeLoading(load);

      } else {
        this.loadding.closeLoading(load);
        this.alert.showAlert(s.Error);
      }
    }).catch(err => {
      this.loadding.closeLoading(load);
      this.alert.showAlert("即将开放，敬请期待!");
    });
  }
  /**
   * 打开ebet界面
   * evan 2019-03-20
   * @memberof GamesLobbyPage
   */
  openEbet() {
    let load = this.loadding.showLoding();
    this.ebetService.loginEbet().then(s => {
      if (s && s.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(s.Error);
        });
        this.loadding.closeLoading(load);

      } else {
        this.loadding.closeLoading(load);
        this.alert.showAlert(s.Error);
      }
    }).catch(err => {
      this.loadding.closeLoading(load);
      this.alert.showAlert("即将开放，敬请期待!");
    });
  }
  /**
  *获取首页轮播图
  *
  * @returns
  * @memberof HomePage
  */
  getMobilePic() {
    return this.sys.getMobileCarousel().then(s => {
      if (s) {
        this.homeArr = s;
        let loading = setInterval(() => {
          if (this.homeArr.length > 0) {
            clearInterval(loading);
          }
        }, 50);
      }
    }).catch(err => {
      console.log(err);
    })
  }
  //真人视频
  //TQQ 2017-12-30
  forwardGame(gameType) {
    if (gameType == -1) {
      this.alert.showAlert('即将开放，敬请期待');
      return;
    }
    let load = this.loadding.showLoding();
    this.agService.forwardGame(gameType).then(s => {
      if (s) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(s);
        });
        this.loadding.closeLoading(load);

      } else {
        this.loadding.closeLoading(load);
        this.alert.showAlert("即将开放，敬请期待!");
      }
    }).catch(() => {
      this.loadding.closeLoading(load);
      this.alert.showAlert("即将开放，敬请期待!");
    });
  }

  /**
     * 判断KY开元棋牌是否开启
     * david 2018-12-29
     * @memberof GamesLobbyPage
     */
  getKaiYuanIsOpen() {
    this.kaiYuanService.getKaiYuanIsOpen().then(s => {
      if (s && s.Error == '已开启') {
        this.openky()
      } else {
        this.alert.showAlert("即将开放，敬请期待!");
        return;
      }
    }).catch((err) => {
      this.alert.showAlert("即将开放，敬请期待!");
      return;
    })
  }
  /**
     * 进入KY开元棋牌
     * david 2018-12-29
     * @memberof GamesLobbyPage
     */
  openky() {
    let load = this.loadding.showLoding();
    this.kaiYuanService.login().then((res) => {
      if (res && res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
        this.loadding.closeLoading(load);

      }
      else {
        this.loadding.closeLoading(load);
        this.alert.showAlert("即将开放，敬请期待!");
      }
    }).catch((err) => {
      this.loadding.closeLoading(load);
      this.alert.showAlert("即将开放，敬请期待!");
    });
  }

  /**
   * @params 判断加玛棋牌是否开启
   * @param author An 2019-12-05
   */
  getGamMaIsOpen() {
    this.gamMaService.getGamMaIsOpen().then(s => {
      if (s && s.Error == '已开启') {
        this.openGamMa()
      } else {
        this.alert.showAlert("即将开放，敬请期待!");
        return;
      }
    }).catch((err) => {
      this.alert.showAlert("即将开放，敬请期待!");
      return;
    })
  }
  /**
   * @params 进入加玛棋牌
   * @param author An 2019-12-05
   */
  openGamMa() {
    let load = this.loadding.showLoding();
    this.gamMaService.loginGamMa().then((res) => {
      if (res && res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
        this.loadding.closeLoading(load);

      }
      else {
        this.loadding.closeLoading(load);
        this.alert.showAlert("即将开放，敬请期待!");
      }
    }).catch((err) => {
      this.loadding.closeLoading(load);
      this.alert.showAlert("即将开放，敬请期待!");
    });
  }
  // 获取所有彩种
  // TQQ 2017-01-12
  getLotterysAll() {
    var lotterys = this.storage.read("lotterys");
    if (lotterys == null) {
      return this.lotterylatestService.getLotterys().then(s => {
        this.storage.write("lotterys", s);
        this.getVr();
      });
    }
    this.getVr();
    return Promise.resolve();
  }

  //获取vr
  //TQQ 2018-02-02
  getVr() {
    this.vrService.getVRisOpen().then(v => {
      if (v) {
        AppConfig.VrIsOpen = v.Result;
        if (v.Result) {
          let vrlottery: LotteryModel = { BlockTime: '', LotteryCode: 'vr', LotteryName: 'VR彩票', ID: 0, IsAuto: false, LotteryPlayModeCode: '', LotteryPlayModeName: '', LotteryType: '', LotteryTypeName: '', NumLength: 0, OpenLength: 0, RewardDown: 0, RewardUp: 0, State: '01' };
          this.lotterys.splice(0, 0, vrlottery);
        }
        if (this.likes.length > 0 && !v.Result) {
          var idx = this.likes.findIndex(s => s.LotteryCode == 'vr');
          if (idx > -1) {
            this.likes.splice(idx, 1);
            this.storage.write('likes', this.likes);
          }
        }
      }
    });

    //获取ug
    // this.vrService.loginUg().then(u => {
    //   if (u) {
    //     this.ugUrl = u;
    //     let uglottery: LotteryModel = { BlockTime: '', LotteryCode: 'ug', LotteryName: 'UG体育', ID: 0, IsAuto: false, LotteryPlayModeCode: '', LotteryPlayModeName: '', LotteryType: '', LotteryTypeName: '', NumLength: 0, OpenLength: 0, RewardDown: 0, RewardUp: 0, State: '01' };
    //     this.lotterys.splice(0, 0, uglottery);
    //     if (this.likes.length > 0 && !u.Result) {
    //       var idx = this.likes.findIndex(s => s.LotteryCode == 'ug');
    //       if (idx > -1) {
    //         this.likes.splice(idx, 1);
    //         this.storage.write('likes', this.likes);
    //       }
    //     }
    //   }
    // }).catch(err => {
    //   console.log(err);

    // });
  }


  //选择用户喜欢的彩种
  ziDingYi() {
    let modal = this.modalCtrl.create(LotteryAllPage, { lotterys: this.lotterys, likes: this.likes });
    modal.present();
    modal.onWillDismiss((likesAll: any[]) => {
      this.all = likesAll;
    });
  }

  //进入投注页
  goBetting(lotteryCode: string) {
    switch (lotteryCode) {
      case 'vr':
        this.vrService.openVr().then(v => {
          if (v) {
            if (v.Result) {
              this.alert.showConfirm('新窗口打开游戏？', () => {
                this.config.openUrl(v.Parameter);
              });
            } else {
              this.alert.showAlert(v.Error);
            }
          }
        });
        break;
      case 'ug':
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(this.ugUrl);
        });
        break;
      default:
        BettingParamService.applyPlayModeBeforeNavigate(lotteryCode, this.storage);
        this.navCtrl.push(BettingOrderPage, {
          lotteryCode: lotteryCode
        });
    }
  }
  /**
   * 进去im体育游戏
   */
  getImtIsOpen() {
    this.imService.loginImt().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      }

    })
  }

  /**
   * 进去CR皇冠体育游戏
   */
  getCRIsOpen() {
    this.imService.loginCR().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      } else {
        this.alert.showAlert(res.Error)
      }

    })
  }

  /**
   * 进去PG电子游戏
   */
  getPGIsOpen() {
    this.imService.loginPG().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.storage.write('ThirdCode', res.Error);
          let urlStr = location.href + '?thirdCode';
          this.iab.create(urlStr, '_system');
        });
      } else {
        this.alert.showAlert(res.Error)
      }

    })
  }

  /**
 * 进去Ob体育游戏
 */
  getObIsOpen() {
    this.yaboService.loginOb().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      }

    })
  }


  /**
   * 进去亚星真人游戏
   */
  getYxIsOpen() {
    this.yxService.login().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      } else {
        this.alert.showAlert(res.Error)
      }
    })
  }
  /**
 * 进去凯旋棋牌游戏
 */
  getKaiXuanIsOpen() {
    this.kxService.login().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      } else {
        this.alert.showAlert(res.Error)
      }
    })
  }
  /**
   * 进入DB真人游戏
   */
  getPmIsOpen() {
    this.pmService.loginPm().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      } else {
        this.alert.showAlert(res.Error)
      }
    })
  }
  /**
   * 进入bg真人游戏
   */
  getBgIsOpen() {
    this.pmService.loginBg().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      } else {
        this.alert.showAlert(res.Error)
      }
    })
  }

  /**
   * 进去欧博真人游戏
   */
  getOuBoIsOpen() {
    this.imService.loginOuBo().then(res => {
      if (res.Result) {
        this.alert.showConfirm('新窗口打开游戏？', () => {
          this.config.openUrl(res.Error);
        });
      } else {
        this.alert.showAlert(res.Error)
      }

    })
  }

  //在线客服
  //TQQ 2017-01-19
  customer() {
    let connect = this.storage.read<SysconfigModel>("sysconfig");
    this.config.openUrl(connect.CustomerServiceUrl);
  }



  //退出
  //chen 2017-02-20
  exit() {
    this.storage.remove("token");
    this.navCtrl.push(SigninPage);
  }

  goToPage(obj) {
    this.navCtrl.push(obj);
  }

  toActivity() {
    // this.navCtrl.push(ActivityPage);
    this.alert.showAlert('即将开放，敬请期待');
  }

  verifyBindStatus(func = null) {
    if (!this.bindStatus.isBindPassword) {
      this.alert.showConfirm('您还没有绑定资金密码，前往绑定', () => {
        this.navCtrl.push(RevisePage, { information: 1 });
      }, '提示', null, false);
    } else if (!this.bindStatus.isBindCard) {
      this.alert.showConfirm("请先绑定钱包地址/银行卡！", () => {
        this.navCtrl.push(UserBankList);
      }, '提示', null, false);
    } else {
      func && func();
    }
  }

  //home页充值
  //chen 2017-02-20
  deposit() {
    const func = () => this.navCtrl.push(RechargePage);
    this.verifyBindStatus(func);
  }

  //home页提现
  //chen 2017-02-20
  withdraw() {
    const func = () => this.navCtrl.push(WithdrawPage);
    this.verifyBindStatus(func);
  }

  //home页游戏记录
  //chen 2017-02-20
  openNormal() {
    this.navCtrl.push(NormalReport);
  }

  //home页优惠活动
  //chen 2017-02-20
  openPromotion() {
    this.navCtrl.push(PromotionPage);
  }

  //彩种选择切换
  //chen 2017-02-20
  lotteryClick(type) {
    this.flagChecked = type;
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts